import Hero from "@/components/Hero";
import ServiceCard from "@/components/ServiceCard";
import WhyChooseUs from "@/components/WhyChooseUs";
import Gallery from "@/components/Gallery";
import Team from "@/components/Team";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import Testimonials from "@/components/Testimonials";
import { Scissors, Brush, Sparkles, Palette, Gem } from "lucide-react";

const Index = () => {
  const services = [
    {
      icon: Scissors,
      title: "Coiffure",
      description: "Des coupes et coiffures personnalisées par nos experts stylistes.",
    },
    {
      icon: Gem,
      title: "Onglerie",
      description: "Manucure et pédicure professionnelles pour des ongles parfaits.",
    },
    {
      icon: Brush,
      title: "Make-up",
      description: "Maquillage professionnel pour toutes vos occasions spéciales.",
    },
    {
      icon: Palette,
      title: "Produits Cosmétiques",
      description: "Une sélection de produits de beauté haut de gamme.",
    },
    {
      icon: Sparkles,
      title: "Soins & Divers",
      description: "Des soins personnalisés pour sublimer votre beauté naturelle.",
    },
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <section className="py-16 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Nos Services
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Découvrez notre gamme complète de services de beauté professionnels.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <ServiceCard key={index} {...service} />
            ))}
          </div>
        </div>
      </section>
      <WhyChooseUs />
      <Gallery />
      <Team />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default Index;